import { apiSlice } from "application/api/apiSlice";
import { API_PREFIX } from "data/constants";

export const bookingApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    startBooking: builder.mutation({
      query: ({ bookings }) => ({
        url: API_PREFIX + "/booking/start",
        method: "POST",
        body: {
          bookings,
        },
      }),
      invalidatesTags: ["Booking"],
    }),
    getBookingOutcome: builder.query({
      query: (session_id) => ({
        url: API_PREFIX + `/booking/outcome/${session_id}`,
        method: "GET",
      }),
      transformResponse: (response) => ({
        outcome: response.outcome.outcome,
      }),
      invalidatesTags: ["Booking"],
    }),
    checkExperienceAvailability: builder.query({
      query: ({ experience }) => ({
        url: API_PREFIX + "/booking/experience/availability",
        method: "POST",
        body: { experience },
      }),
    }),
    cancelBooking: builder.mutation({
      query: (booking) => ({
        url: API_PREFIX + "/booking/cancel",
        method: "POST",
        body: {
          booking,
        },
      }),
      invalidatesTags: ["Booking"],
    }),
    rejectBooking: builder.mutation({
      query: (booking) => ({
        url: API_PREFIX + "/booking/reject",
        method: "POST",
        body: {
          booking,
        },
      }),
      invalidatesTags: ["Booking"],
    }),
    getBookingDetails: builder.query({
      query: (booking_id) => ({
        url: API_PREFIX + `/booking/details/${booking_id}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useStartBookingMutation,
  useGetBookingOutcomeQuery,
  useLazyGetBookingOutcomeQuery,
  useLazyCheckExperienceAvailabilityQuery,
  useCancelBookingMutation,
  useRejectBookingMutation,
  useGetBookingDetailsQuery,
} = bookingApiSlice;
